import React, { useState } from 'react';
import {
  Box, Flex, VStack, Text, IconButton, Button, Modal, ModalOverlay,
  ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure, Link
} from '@chakra-ui/react';
import { FaBookmark, FaExclamationTriangle, FaDollarSign, FaBuilding, FaCheckCircle, FaShareAlt, FaClock, FaLink, FaMapMarkerAlt } from 'react-icons/fa';
import { BsChatText } from 'react-icons/bs';
import AboutCompany from './aboutCompany';
import ClockInModal from './clockin';
import axios from 'axios';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useJobListRefreshContext } from '../../utils/context/JobListRefresh';

const JobCard = ({ category, isFromApprovedList, ...jobs }) => {
  const { triggerJobListRefresh } = useJobListRefreshContext();
  const [isFavorited, setIsFavorited] = useState((category === 'All' || category === 'Saved') && jobs.isSaved);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isApplied } = jobs;
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [isAboutCompanyOpen, setIsAboutCompanyOpen] = useState(false);

  const { isOpen: isConfirmationOpen, onOpen: onConfirmationOpen, onClose: onConfirmationClose } = useDisclosure();
  const { isOpen: isWithdrawConfirmationOpen, onOpen: onWithdrawConfirmationOpen, onClose: onWithdrawConfirmationClose } = useDisclosure();
  const { isOpen: isWithdrawSuccessOpen, onOpen: onWithdrawSuccessOpen, onClose: onWithdrawSuccessClose } = useDisclosure();

  const isAssignedCategory = category === 'Assigned';
  const isCompletedCategory = category === 'Completed';

  const handleWithdraw = (jobId) => {
    const withdrawApplication = async (jobId) => {
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
        console.error('No ticket token found in sessionStorage');
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/applicant/withdraw-application`,
          { jobId },
          { headers: { Authorization: `Bearer ${ticketToken}` } }
        );
        if (response.status === 200) {
          console.log(response.data.status);
          if (response.data.status === "Hired") {
            Swal.fire({
              icon: 'error',
              title: 'Application Failed',
              text: 'You are already hired for this job please refresh the page',
              showConfirmButton: false,
              timer: 3000,
              width: '300px',
              padding: '1em',
            });
            onClose();
          } else if (response.data.status === "success") {
            onWithdrawSuccessOpen();
           // Close the confirmation modal
          }
          onWithdrawConfirmationClose();
          triggerJobListRefresh();
        }
      } catch (error) {
        Swal.fire({
          width: '300px',
          timer: 4000,
          timerProgressBar: true,
          icon: 'error',
          title: 'Error!',
          text: "Error withdrawing application"
        });
        console.error('Error withdrawing Application:', error);
        onWithdrawConfirmationClose();
      }
    };
    withdrawApplication(jobId);
  }

  const handleAboutCompanyOpen = (e) => {
    e.stopPropagation();
    setIsAboutCompanyOpen(true);
  };

  const handleAboutCompanyClose = () => {
    setIsAboutCompanyOpen(false);
  };

  const handleShareClick = (e) => {
    e.stopPropagation();
    // Add your share logic here
  };

  const handleFavoriteClick = async (e) => {
    e.stopPropagation();
    setIsFavorited(!isFavorited);

    const ticketToken = sessionStorage.getItem('ticketToken');
    console.log("hahahahaha", ticketToken);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/applicant/toggle-save-job`,
        { jobId: jobs._id },
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`
          }
        }
      );

    } catch (error) {
      console.error("Error toggling job save status:", error);
    }
  };

  const handleApply = (jobId) => {
    const applyForJob = async () => {
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
        console.error('No ticket token found in sessionStorage');
        return;
      }
  
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/applicant/apply-for-job`,
          { jobId },
          { headers: { Authorization: `Bearer ${ticketToken}` } }
        );
        setAppliedJobs(response.data.data);
        if (response.status === 200) {
          if(response.data.status === "Assigned"){
            Swal.fire({
              icon: 'error',
              title: 'Application Failed',
              text: 'The job you are trying to apply for overlaps with an existing assigned job.',
              showConfirmButton: false,
              timer: 3000,
              width: '300px',
              padding: '1em',
            });
            onClose(); // Ensure modal closes in this case as well
          }
          else{
            Swal.fire({
              icon: 'success',
              title: 'Application Submitted!',
              text: 'Your application has been submitted successfully. You can view this job in your applied job section.',
              showConfirmButton: false,
              timer: 3000,
              width: '300px',
              padding: '1em',
              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              }
            });
            triggerJobListRefresh();
            onClose();
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Application Failed',
            text: 'Application submission failed. Please try again.',
            footer: '<a href="#">Why do I have this issue?</a>',
            width: '300px',
            padding: '1em',
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          });
        }
      } catch (err) {
        console.log(err);
        toast.error('Error applying for job');
      }
    }
    applyForJob();
  }

  let providerName = 'Unknown Provider';
  if (jobs.providerInfo) {
    if (jobs.providerInfo.role === "individual_provider") {
      providerName = `Job sourced by ${jobs.providerInfo.FullName}`;
    } else {
      providerName = jobs.providerInfo.FullName || 'Unknown Provider';
    }
  } else {
    // Handle case when providerInfo is undefined
    providerName = 'Unknown Provider';
  }
 
  
  const salary = jobs.formattedSalary;
  const jobDates = jobs.formattedDatetime;
  const location = jobs.formattedLocation;
  const timeAgo = jobs.timeAgo === 0 ? 'today' : `${jobs.timeAgo} day ago`;
  const isFeatured = false;
  const matchCount = jobs.matchCount;
  const lengthofskills = jobs.skills.length;
  const totalHours = jobs.totalHours;
  const isNewChat = jobs.isNewChat;

  const isToday = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  };

  const isCurrentOrAfterStartTime = (startTime) => {
    const now = new Date();
    const [startHour, startMinute] = startTime.split(':').map(Number);
    return now.getHours() > startHour || (now.getHours() === startHour && now.getMinutes() >= startMinute);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toISOString().split('T')[0];
  };

  const jobStartDateFormatted = formatDate(jobs.jobStartDate);
  const jobEndDateFormatted = formatDate(jobs.jobEndDate);

  const handleChatClick = (jobId) => {
    console.log("Navigating to chat with job ID:", jobId);
    // Add your navigation logic here
  };
  // Split formattedDatetime into start and end if it exists
  const formjobDates = jobs.formattedDatetime
  ? jobs.formattedDatetime.split(" - ")
  : ["N/A", "N/A"];
  return (
    <>
    {isFromApprovedList ? (
        <Box
          borderWidth="1px"
          borderRadius="lg"
          overflow="hidden"
          p={3}
          mb={3}
          boxShadow="md"
          _hover={{ boxShadow: 'lg', transform: 'scale(1.02)' }}
          transition="all 0.3s ease-in-out"
          width="300px" // Increased width
          height="125px" // Decreased height
          position="relative"
          onClick={onOpen}
          cursor="pointer"
          bgGradient="linear(to-l, blue.500, blue.300)"
          color="white"
        >
          <Flex align="center" justify="space-between">
            <Flex align="flex-start">
              <Box as={FaBuilding} boxSize={8} mr={3} color="white" />
              <VStack align="start" spacing={1}>
                <Text fontWeight="bold" fontSize="md" fontFamily="body">
                  {jobs.jobTitle}
                </Text>
                <Text fontSize="xs" color="gray.200" fontFamily="body">
                  {providerName}
                </Text>
                <Flex align="center" fontSize="xs" color="gray.200">
                  <Box as={FaMapMarkerAlt} mr={1} />
                  <Text>{location}</Text>
                </Flex>
              </VStack>
            </Flex>
            <Flex align="center" position="absolute" top={2} right={2}>
              {jobs.isFeatured && (
                <FaCheckCircle
                  style={{
                    color: 'blue',
                    width: '24px',
                    height: '24px',
                    marginRight: '8px',
                    paddingTop: '6px',
                    paddingLeft: '6px',
                  }}
                />
              )}
            </Flex>
          </Flex>
          
          {/* Start Date Button */}
          <Button
            size="xs"
            color="blue.700"
            variant="solid"
            position="absolute"
            bottom={2}
            left={2}
            bg="blue.100"
          >
            {formjobDates[0] || 'N/A'}
          </Button>
          
          {/* End Date Button */}
          <Button
            size="xs"
            color="blue.700"
            variant="solid"
            position="absolute"
            bottom={2}
            left="170px" // Adjusted to place it parallel to the Start Date button
            bg="blue.100"
          >
            {formjobDates[1] || 'N/A'}
          </Button>
        </Box>
      ) : (
        // Default Job Card design for other categories
      <Box
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        p={4}
        mb={4}
        boxShadow="md"
        _hover={{ boxShadow: 'lg', transform: 'scale(1.02)' }}
        transition="all 0.3s ease-in-out"
        height="200px"
        position="relative"
        onClick={onOpen}
        cursor="pointer"
      >
        <Flex align="center" justify="space-between">
          <Flex align="flex-start">
            <Box as={FaBuilding} boxSize={10} mr={4} color="gray.500" />
            <VStack align="start" spacing={1}>
              <Text fontWeight="bold" fontSize="lg" fontFamily="body">
                {jobs.jobTitle}
              </Text>
              <Text fontSize="sm" color="gray.500" fontFamily="body">
                {providerName}
              </Text>
              <Flex align="center" fontSize="sm" color="gray.500">
                <Box as={FaMapMarkerAlt} mr={1} />
                <Text>{location}</Text>
              </Flex>
              <Flex align="center" fontSize="sm" color="gray.500">
                <Box as={FaDollarSign} mr={1} />
                <Text>{salary}</Text>
              </Flex>
              <Flex align="center" fontSize="sm" color="gray.500">
                <Box as={FaClock} mr={1} />
                <Text>{jobDates}</Text>
              </Flex>
            </VStack>
          </Flex>
          <Flex align="center" position="absolute" top={2} right={2}>
            {isFeatured && (
              <FaCheckCircle
                style={{
                  color: 'blue',
                  width: '24px',
                  height: '24px',
                  marginRight: '8px',
                  paddingTop: '6px',
                  paddingLeft: '6px',
                }}
              />
            )}

            {category === 'Assigned' && (
              <Box position="relative">
                <IconButton
                  aria-label="Chat"
                  icon={<BsChatText color="black" size="20px" />}
                  onClick={() => handleChatClick(jobs._id)}
                  variant="ghost"
                  mr={0}
                />
                {isNewChat === true && (
                <Box
                  position="absolute"
                  top="6px"
                  left="22px"
                  bg="red.500"
                  color="white"
                  borderRadius="full"
                  width="12px"
                  height="12px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="10px"
                  fontWeight="bold"
                >
                  
                  </Box>
                )}
              </Box>
            )}

            <IconButton
              aria-label="Share job"
              icon={<FaShareAlt color="black" />}
              onClick={handleShareClick}
              variant="ghost"
              mr={2}
            />
            {category !== 'Applied' && (
              <IconButton
                aria-label="Save job"
                icon={
                  <FaBookmark
                    style={{
                      stroke: 'black',
                      strokeWidth: '8px',
                      fill: isFavorited ? 'teal' : 'none',
                      width: '22px',
                      height: '22px',
                      paddingTop: '4px',
                      paddingLeft: '2px',
                    }}
                  />}
                onClick={handleFavoriteClick}
                variant="unstyled"
                _hover={{ transform: 'scale(1.2)', background: 'none' }}
                _active={{ transform: 'scale(1.1)', background: 'none' }}
                transition="transform 0.2s ease-in-out"
                boxSize={8}
              />
            )}
          </Flex>

          
          {/* New Box for Total Work Hours */}
          {/* <Box
            bg="teal.500"
            p={2}
            borderRadius="full"
            boxShadow="lg"
            position="absolute"
            right={2}
            top="50%"
            transform="translateY(-50%)"
            color="white"
            textAlign="center"
            fontWeight="bold"
          >
            <Text fontSize="sm">
              {totalHours} hr
            </Text>
          </Box> */}


        </Flex>
        <Button
          size="xs"
          color="red.400"
          variant="solid"
          position="absolute"
          bottom={2}
          left={2}
          bg="red.100"
        >
          {jobs.hiredCandidates ? `${jobs.vacancies - jobs.hiredCandidates.length} vacancies` : `${jobs.vacancies} vacancies`}
        </Button>
        {matchCount > 0 && (
          <Button
            size="xs"
            color="green.400"
            variant="solid"
            position="absolute"
            bottom={2}
            left={24} // Adjust this value to position the button
            bg="green.100"
          >
            Eligible
          </Button>
        )}
        <Text
          fontSize="xs"
          color="gray.500"
          position="absolute"
          bottom={2}
          right={2}
        >
          {timeAgo}
        </Text>
      </Box>
      )}

      {/* AboutCompany Modal */}
      <Modal isOpen={isAboutCompanyOpen} onClose={handleAboutCompanyClose} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent >
          <ModalCloseButton />
          <ModalBody>
            <AboutCompany />
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* ClockIn Modal */}
      {/* {(isAssignedCategory && isToday(jobStartDate) && isCurrentOrAfterStartTime(jobs.startTime)) || category === 'Completed' && ( */}
      {(isAssignedCategory || isCompletedCategory || isFromApprovedList) && (
        <ClockInModal
          isOpen={isOpen}
          onClose={onClose}
          jobId={jobs._id}
          jobTitle={jobs.jobTitle}
          company={providerName}
          location={location}
          shareLink={jobs.shareLink}
          jobDates={jobDates}
          salary={salary}
          description={jobs.description}
          skills={jobs.skills.join(', ')}
          // mandatorySkills={jobs.mandatorySkills.join(', ')}
          currencyType={jobs.currencyType}
          requirements={jobs.requirements}
          settlementPeriod={jobs.settlementPeriod}
          jobStartDate={jobStartDateFormatted}
          jobEndDate={jobEndDateFormatted}
          jobStartTime={jobs.startTime}
          jobEndTime={jobs.endTime}
          onChatClick={() => handleChatClick(jobs._id)}
          category={category}
        />
      )}

      {/* Existing Job Details Modal */}
      {!isAssignedCategory && !isCompletedCategory && !isFromApprovedList && (
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          size="lg"
          isCentered
          motionPreset="scale"
        >
          <ModalOverlay />
          <ModalContent
            maxW={["90%", "90%", "50%"]}
            h="90vh"
            mx={["5%", "5%", "25%"]}
            my="5vh"
            transition="all 0.3s ease-in-out"
          >
            <ModalHeader>
              <Text fontWeight="bold" fontSize="xl">{jobs.jobTitle}</Text>
              <Flex>
                <Link
                  onClick={handleAboutCompanyOpen}
                  isExternal
                  display="flex"
                  alignItems="center"
                  color="blue.500"
                >
                  <Text fontSize="md" color="blue.500">{jobs.providerInfo?.FullName || 'Unknown Provider'}</Text>
                  <Text fontSize="md" color="blue.500">• {location}</Text>
                  <Box as={FaLink} boxSize={4} ml={2} color="blue.500" />
                </Link>
              </Flex>
            </ModalHeader>
            <ModalCloseButton
              color="black"
              _hover={{ color: 'white', bg: 'blue.500' }}
            />

            <ModalBody
              overflowY="auto"
              css={{
                '&::-webkit-scrollbar': {
                  width: '8px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: 'gray',
                  borderRadius: '24px',
                },
              }}
            >
              {jobs.matchCount === 0 && (
                <Box
                  bg="red.100"
                  p={3}
                  mb={4}
                  borderRadius="md"
                  display="flex"
                  alignItems="center"
                >
                  <Box as={FaExclamationTriangle} color="red.500" mr={2} />
                  <Text color="red.500">
                    You don't have the required skills for this job. Please update your skillset.
                  </Text>
                </Box>
              )}

              <Flex align="center" mb={4}>
                <FaClock style={{ marginRight: '8px' }} />
                <Text>{jobDates}</Text>
              </Flex>
              <Flex align="center" mb={4}>
                <FaDollarSign style={{ marginRight: '8px' }} />
                <Text>{salary}</Text>
              </Flex>

              <Flex justify="space-between" align="center" mb={4}>
                <Button
                  colorScheme={isApplied ? "red" : "green"}
                  flex="1"
                  onClick={() => isApplied ? onWithdrawConfirmationOpen() : handleApply(jobs._id)}
                  disabled={jobs.matchCount === 0 || jobs.matchCount === null}
                >
                  {isApplied ? "Withdraw Application" : "Apply"}
                </Button>
                <Flex ml={2}>
                  <IconButton
                    aria-label="Share job"
                    icon={<FaShareAlt color="black" />}
                    onClick={handleShareClick}
                    variant="ghost"
                    mr={2}
                  />
                  {category !== 'Applied' && (
                    <IconButton
                      aria-label="Save job"
                      icon={
                        <FaBookmark
                          style={{
                            stroke: 'black',
                            strokeWidth: '8px',
                            fill: isFavorited ? 'teal' : 'none',
                            width: '22px',
                            height: '22px',
                            paddingTop: '4px',
                            paddingLeft: '2px',
                          }}
                        />}
                      onClick={handleFavoriteClick}
                      variant="unstyled"
                      _hover={{ transform: 'scale(1.2)', background: 'none' }}
                      _active={{ transform: 'scale(1.1)', background: 'none' }}
                      transition="transform 0.2s ease-in-out"
                      boxSize={8}
                    />
                  )}
                </Flex>
              </Flex>

              <Text fontWeight="bold" mb={2}>Description</Text>
              <Text mb={4}>{jobs.description}</Text>

              <Text fontWeight="bold" mb={2}>Payment Period</Text>
              <Text mb={4}>within {jobs.settlementPeriod || 'Not specified'} </Text>

              <Text fontWeight="bold" mb={2}>Work Address</Text>
              <Text mb={4}>{jobs.address}</Text>
              <Text fontWeight="bold" mb={2}>Required Skills</Text>
              <Flex mb={4} wrap="wrap">
                {jobs.skills.map((skill, index) => (
                  <Box
                    key={index}
                    bg="gray.100"
                    p={2}
                    m={1}
                    borderRadius="md"
                    boxShadow="sm"
                  >
                    {skill}
                  </Box>
                ))}
              </Flex>

              <Text fontWeight="bold" mb={2}>{matchCount} of {lengthofskills} Mandatory Skills matched</Text>
              <Flex mb={4} wrap="wrap">
                {jobs.matchedSkills.map((skill, index) => (
                  <Box
                    key={index}
                    bg="gray.100"
                    p={2}
                    m={1}
                    borderRadius="md"
                    boxShadow="sm"
                  >
                    {skill}
                  </Box>
                ))}
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme={isApplied ? "red" : "green"}
                width="100%"
                onClick={() => isApplied ? onWithdrawConfirmationOpen() : handleApply(jobs._id)}
                disabled={jobs.matchCount === 0 || jobs.matchCount === null}
              >
                {isApplied ? "Withdraw Application" : "Apply"}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {/* Confirmation Modal */}
      <Modal isOpen={isConfirmationOpen} onClose={onConfirmationClose} size="md" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirmation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Job applied successfully. Do you want to view this job in your applied job section?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={() => { onConfirmationClose(); toast.success("Job applied successfully. You can view this job in your applied job section."); }}>
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Withdraw Confirmation Modal */}
      <Modal isOpen={isWithdrawConfirmationOpen} onClose={onWithdrawConfirmationClose} size="md" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Withdraw Confirmation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to withdraw your application for this job?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={() => { handleWithdraw(jobs._id); }}>
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Withdraw Success Modal */}
      <Modal isOpen={isWithdrawSuccessOpen} onClose={onWithdrawSuccessClose} size="md" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Success</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Your application has been successfully withdrawn.</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" onClick={() => { onWithdrawSuccessClose(); onClose(); }}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default JobCard;